import { useState, useEffect } from "react";
import MainLayouts from "../../../Layout/MainLayouts";
import { ReactComponent as ArrowLeftSquare } from "bootstrap-icons/icons/arrow-left-square-fill.svg";
import Spinner from "../../spinner/Spinner";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import ApiServices from "../../../api/ApiServices";
import { toast } from "react-toastify";
import { handleError } from "../../../components/utils/AuthenticationCheck";
import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";
// import { ReactComponent as PencilSquare } from "bootstrap-icons/icons/pencil-square.svg";
// import { ReactComponent as Trash } from "bootstrap-icons/icons/trash.svg";
import { ReactComponent as CardList } from "bootstrap-icons/icons/card-list.svg";
import { ReactComponent as PlusSquareFill } from "bootstrap-icons/icons/plus-square-fill.svg";
import AxiosApiCall from "../../../api/AxiosApiCall";
import DataTable from "react-data-table-component";
import CustomStyles from "../../../components/utils/CustomStyles";
// import formatDate from "../../../components/utils/DateFormatter";

const GetExpenseById = () => {
  const [expenseDetails, setExpenseDetails] = useState({
    summary: {},
    expenses: [],
  });
  const [branch_id, setBranchId] = useState("");
  const [loading, setLoading] = useState(false);
  const [funding, setFunding] = useState(false);
  const [confirmationLoading, setConfirmationLoading] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [perPage, setPerPage] = useState(50);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);


  const navigate = useNavigate();
  const location = useLocation();
  const { data } = location.state || {}
  // console.log("data", data);

  useEffect(() => {
    if (data) {
      setBranchId(data.branch_info.id);
    }
  }, [data]);



  //axios api encryption call
  const axios = AxiosApiCall();

  const fetchBranchDetails = async () => {
    if (!branch_id) return;
    setLoading(true);
    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) throw new Error("No access token found.");

      const response = await axios.get(ApiServices.getExpenseOpeById, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          branch_id,
          page: page,
          per_page: perPage,
        },
        withCredentials: true,
      });

      const { status, message, data } = response.data;
      if (status === 200) {
        setExpenseDetails(data);
        setTotal(data.total);
        setPerPage(data.per_page);
        setPage(data.current_page);
        toast.success(message, { toastId: "incentive-fetch-success" });

      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (branch_id) {
      fetchBranchDetails();
    }
  }, [branch_id, page, perPage]);


  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handlePerRowsChange = (newPerPage, newPage) => {
    setPerPage(newPerPage);
    setPage(newPage);
  };




  // Handle branch activation
  const handleDeleteIncentives = async (branchId) => {
    const formData = {
      branch_id: branchId,
    };
    try {
      setConfirmationLoading(true);
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) {
        throw new Error("No access token found.");
      }
      const response = await axios.delete(ApiServices.deleteBranchOpeCreateIncentives, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: formData,
        withCredentials: true,
      });
      const { status, message } = response.data;
      if (status === 200) {
        toast.success(message, { toastId: "incentive-deleted-success" });
        await fetchBranchDetails();
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setConfirmationLoading(false);
    }
  };


  // Handle Delete Confirmation
  const handleDeleteConfirmation = (branchId) => {
    setConfirmationLoading(true);
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      setConfirmationLoading(false);
      if (result.isConfirmed) {
        handleDeleteIncentives(branchId);
      }
    });
  };


  // fund incentive
  const handleFundIncentive = async () => {
    const { value: formValues } = await Swal.fire({
      title: "Fund Branch Incentive",
      html: `
      <input id="amount" type="number" placeholder="Amount"
        class="w-full px-4 py-2 border border-gray-300 rounded-md mb-3" />
      <input id="description" type="text" placeholder="Description"
        class="w-full px-4 py-2 border border-gray-300 rounded-md mb-3" />
        <input id="effective_date" type="date"
  class="w-full px-4 py-2 border border-gray-300 rounded-md mb-3" />
      <select id="category"
        class="w-full px-4 py-2 border border-gray-300 rounded-md mb-3">
          <option value="">Select Category</option>
          <option value="performance">Performance</option>
          <option value="sales_target">Sales Target</option>
          <option value="customer_service">Customer Service</option>
          <option value="special_achievement">Special Achievement</option>
          <option value="monthly_bonus">Monthly Bonus</option>
          <option value="quarterly_bonus">Quarterly Bonus</option>
          <option value="annual_bonus">Annual Bonus</option>
          <option value="other">Other</option>
      </select>
      <textarea id="notes" placeholder="Notes"
        class="w-full px-4 py-2 border border-gray-300 rounded-md mb-1 resize-none h-24"></textarea>
    `,

      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Fund",
      preConfirm: () => {
        const amount = parseFloat(document.getElementById("amount").value);
        const description = document.getElementById("description").value;
        const category = document.getElementById("category").value;
        const notes = document.getElementById("notes").value;
        const effective_date = document.getElementById("effective_date").value;

        if (!amount || !description) {
          Swal.showValidationMessage(`Amount and description are required`);
          return;
        }

        return { amount, description, category, notes, effective_date };
      },
    });

    if (formValues) {
      try {
        setFunding(true);
        const authData = JSON.parse(localStorage.getItem("auth"));
        const token = authData?.token;
        if (!token) throw new Error("No access token found.");

        const formData = {
          branch_id,
          amount: formValues.amount,
          description: formValues.description,
          category: formValues.category,
          notes: formValues.notes,
          ...(formValues.effective_date && { effective_date: formValues.effective_date }),
        };


        // console.log("pay load ", formData);

        const response = await axios.post(ApiServices.BranchOpeCreateIncentives, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        });

        const { status, message } = response.data;
        if (status === 200) {
          toast.success(message, { toastId: "incentive-created-success" });
          await fetchBranchDetails();
        } else {
          handleError({ response: { status, data: { message } } }, navigate);
        }
      } catch (error) {
        handleError(error, navigate);
      } finally {
        setFunding(false);
      }
    }
  };




  const columns = [
    {
      name: "Date",
      selector: (row) =>
        row.created_at ? new Date(row.created_at).toLocaleString() : "N/A",
      sortable: true,
      width: "220px",
    },
    {
      name: "Reference",
      selector: (row) => row.reference || "N/A",
      sortable: true,
      width: "250px",
    },
    {
      name: "Amount",
      selector: (row) => row.amount || "N/A",
      sortable: true,
      width: "150px",
    },
    {
      name: "Category",
      selector: (row) => row.category_name || row.category || "N/A",
      sortable: true,
      width: "200px",
    },
    // {
    //   name: "Custom Category",
    //   selector: (row) => row.custom_category || "N/A",
    //   sortable: true,
    //   width: "180px",
    // },

    {
      name: "Description",
      selector: (row) => row.description || "N/A",
      sortable: true,
      width: "250px",
    },
    // {
    //   name: "Status",
    //   cell: (row) => (
    //     <span
    //       className={
    //         row.status === "pending"
    //           ? "text-orange1"
    //           : row.status === "approved"
    //             ? "text-dash"
    //             : "text-dash5"
    //       }
    //     >
    //       {row.status?.toUpperCase() || "N/A"}
    //     </span>
    //   ),
    //   sortable: true,
    //   width: "150px",
    // },

  ];


  // const ExpandableComponent = ({ data }) => {
  //   return (
  //     <div className="p-4 bg-gray-50 rounded-md text-sm text-gray-700 grid gap-2">
  //       <p>
  //         <strong>Description:</strong> {data.description || "N/A"}
  //       </p>
  //       <p>
  //         <strong>Category:</strong> {data.category_name || data.category}
  //       </p>
  //       <p>
  //         <strong>Rejection Reason:</strong> {data.rejection_reason || "N/A"}
  //       </p>
  //       <p>
  //         <strong>Approved At:</strong>{" "}
  //         {data.approved_at ? new Date(data.approved_at).toLocaleString() : "Not Approved"}
  //       </p>
  //       <p>
  //         <strong>Paid At:</strong>{" "}
  //         {data.paid_at ? new Date(data.paid_at).toLocaleString() : "Not Paid"}
  //       </p>
  //       {data.receipt_url && (
  //         <p>
  //           <strong>Receipt:</strong>{" "}
  //           <a href={data.receipt_url} className="text-blue-600 underline" target="_blank" rel="noreferrer">
  //             View Receipt
  //           </a>
  //         </p>
  //       )}
  //     </div>
  //   );
  // };

  const handleFilter = (e) => {
    setFilterText(e.target.value);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  const filteredItems = (expenseDetails.expenses || []).filter((item) =>
    Object.keys(item).some((key) =>
      item[key]?.toString().toLowerCase().includes(filterText.toLowerCase())
    )
  );



  return (
    <MainLayouts>
      <div className="relative sm:rounded-lg py-6 w-full">
        <section className="w-full pr-[3%] pt-3 my-3 bg-gray-100">
          <nav className="bg-gray-200 py-0 px-4 rounded-lg">
            <ol className="list-none p-0 inline-flex mb-2">
              <li className="flex items-center">
                <p className="text-darkGreen3 pr-2">Operations Branch</p>
                <ChevronRightIcon />
              </li>
              <li className="flex items-center">
                <p className="text-darkGreen3 pr-2">Expense</p>
                <ChevronRightIcon />
              </li>
              <li className="flex items-center">
                <p className="text-orange1">Detail</p>
              </li>
            </ol>
          </nav>
        </section>

        {loading ? (
          <Spinner loading={loading} />
        ) : (
          <section className="text-gray-600 body-font">
            <div className="container">
              <div className="flex justify-end mb-3">
                {/* <button
                  onClick={handleFundIncentive}
                  disabled={funding}
                  className="mx-2 w-full sm:w-auto text-dGrey3 bg-dash focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                >
                  <span className="flex justify-center sm:justify-start mx-2">
                    <PlusSquareFill className="mr-2" />
                    Fund
                  </span>
                </button> */}

                {/* <Link
                  to="/operations/branch/incentives/stat" state={{ id: branch_id }}
                  className="mx-2 w-full sm:w-auto text-dGrey3 bg-dash4 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                >
                  <span className="flex justify-center sm:justify-start mx-2">
                    <CardList className="mr-2" />
                    Statistc
                  </span>
                </Link> */}
                <Link
                  to="/operations/branch/expenses"
                  className="mx-2 w-full sm:w-auto text-dGrey3 bg-darkGreen3 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                >
                  <span className="flex justify-center sm:justify-start mx-2">
                    <ArrowLeftSquare className="mr-2" />
                    Back
                  </span>
                </Link>

              </div>
              {/* <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12 lg:col-span-12 p-2">
                  <div className="flex items-center border-dash border p-1 rounded-lg border-l-4">
                    <section className="body-font w-full">
                      <div className="container px-2">
                        <div className="w-full flex flex-wrap">
                          <div className="w-full px-4">

                            <div className="flex border-tx border-gray-200 py-2">
                              <span className="text-gray-500">Total Expenses</span>
                              <span className="ml-auto text-dash">
                                {CurrencyFormatter(expenseDetails.summary?.total_expenses || 0)}
                              </span>
                            </div>
                            <div className="flex border-t border-gray-200 py-2">
                              <span className="text-gray-500">Total Paid</span>
                              <span className="ml-auto text-dash">
                                {CurrencyFormatter(expenseDetails.summary?.paid_expenses || 0)}
                              </span>
                            </div>
                            <div className="flex border-t border-gray-200 py-2">
                              <span className="text-gray-500">Total Pending</span>
                              <span className="ml-auto text-dash">
                                {CurrencyFormatter(expenseDetails.summary?.pending_expenses || 0)}
                              </span>
                            </div>
                            <div className="flex border-t border-gray-200 py-2">
                              <span className="text-gray-500">Approved Expenses</span>
                              <span className="ml-auto text-dash">
                                {CurrencyFormatter(expenseDetails.summary?.approved_expenses || 0)}
                              </span>
                            </div>


                            <div className="mt-4">
                              <h3 className="text-gray-700 font-semibold mb-2">Category Breakdown</h3>
                              {expenseDetails.category_breakdown?.length > 0 ? (
                                expenseDetails.category_breakdown.map((item, idx) => (
                                  <div key={idx} className="border-t border-gray-200 py-2">
                                    <div className="flex justify-between">
                                      <span className="text-gray-500 capitalize">{item.category}</span>
                                      <span className="text-dash">{CurrencyFormatter(item.total_amount || 0)}</span>
                                    </div>
                                    <div className="flex justify-between text-sm text-gray-400">
                                      <span>Average Amount </span>
                                      <span>Avg: {CurrencyFormatter(item.average_amount || 0)}</span>
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <p className="text-sm text-gray-400">No category breakdown available.</p>
                              )}
                            </div>

                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div> */}


              <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12 lg:col-span-12 p-2">
                  {/* <div className="flex items-center border-dash border p-1 rounded-lg border-l-4"> */}
                  <section className="body-font w-full">
                    {/* <div className="relative w-full sm:w-1/2 mb-4 sm:mb-0">
                      <input
                        type="search"
                        className="block w-full px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                        placeholder="Search"
                        value={filterText}
                        onChange={handleFilter}
                      />
                    </div> */}
                    <div className="container px-2 mt-4">
                      <DataTable
                        columns={columns}
                        data={filteredItems}
                        pagination
                        highlightOnHover
                        paginationServer
                        paginationRowsPerPageOptions={[20]}
                        paginationTotalRows={total}
                        paginationDefaultPage={page}
                        paginationPerPage={perPage}
                        onChangePage={handlePageChange}
                        onChangeRowsPerPage={handlePerRowsChange}
                        striped
                        customStyles={CustomStyles}
                        noDataComponent={<div>No Expense found for this branch</div>}
                      // expandableRows
                      // expandableRowsComponent={ExpandableComponent}
                      />


                    </div>
                  </section>
                  {/* </div> */}
                </div>
              </div>
            </div>
          </section>
        )}
      </div>
    </MainLayouts>
  );
};

export default GetExpenseById;
